import Footer from "components/Footer";
import NavbarChild from "components/Navbars/NavbarChild";
import { Outlet } from "react-router-dom"
import Navbar from "../Navbars/Navbar";
const Layout = ()=>{
    return(
        <>
        <Navbar>
            <NavbarChild to="/blogs">
                Blogs
            </NavbarChild>
            <NavbarChild to="/events">
                Events
            </NavbarChild>
            <NavbarChild to="/job-posts">
                Careers
            </NavbarChild>
            {/* <a href="https://forms.gle/HYFBjxhXSU8azoPB7">
                <button className="btn btn-primary">
                    Join
                </button>
            </a> */}
        </Navbar>
        <main className="App min-h-screen">
            <Outlet></Outlet>
        </main>
        <Footer/>
        </>
    )
}

export default Layout;